import React, { ReactNode } from 'react';
import { useStyles } from './NoticeStyles';
import { Typography } from '../Typography';
import { ClassNameMap } from '@material-ui/styles';
import InfoIcon from '@material-ui/icons/Info';
import { Box } from '@material-ui/core';
import clsx from 'clsx';

interface INotice {
  className?: string;
  heading: string;
  message: string;
  messageType?: 'default' | 'error' | 'info';
  children?: ReactNode;
}

export const Notice: React.FC<INotice> = ({ className, heading, message, messageType, children }: INotice): JSX.Element => {
  const classes = useStyles();

  const getNoticeContainerStyles = (messageType: INotice['messageType'], classes: ClassNameMap<string>): string => {
    switch (messageType) {
      case 'default':
        return classes.default;
      case 'info':
        return classes.info;
      case 'error':
        return classes.error;
      default:
        return classes.default;
    }
  };

  const getHeadingIcon = (messageType: INotice['messageType']): ReactNode => {
    switch (messageType) {
      case 'info':
        return <InfoIcon className={classes.headingIconInfo}/>;
      default:
        return <></>;
    }
  };

  return (
    <div className={clsx(className, classes.noticeContainer, getNoticeContainerStyles(messageType, classes))}>
      <Box className={classes.headingContainer}>
        {getHeadingIcon(messageType)}
        <Typography variant="h6" className={classes.infoHeading}>
          {heading}
        </Typography>
      </Box>
      <Typography variant="body2"  className={classes.infoMessage}>{message}</Typography>
      {children}
    </div>
  );
};

Notice.defaultProps = {
  messageType: 'default',
};

export default Notice;
